import { render, staticRenderFns } from "./Begin.vue?vue&type=template&id=5e4afc0c&scoped=true&"
import script from "./Begin.vue?vue&type=script&lang=ts&"
export * from "./Begin.vue?vue&type=script&lang=ts&"
import style0 from "./Begin.vue?vue&type=style&index=0&id=5e4afc0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4afc0c",
  null
  
)

export default component.exports